/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.container {
  border-radius: var(--radius-sm, 0.25rem);
  padding: calc(var(--spacing, 0.25rem) * 4);
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
}
.button {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
}
.title {
  text-align: left;
  display: flex;
  align-items: center;
  gap: calc(var(--spacing, 0.25rem) * 2);
}
.panel {
  text-align: left;
  list-style-type: disc;
  padding-left: calc(var(--spacing, 0.25rem) * 10);
  margin-top: calc(var(--spacing, 0.25rem) * 2);
}
.container.info-light {
  background-color: var(--color-neutral-light, #f5f5f5);
}
.container.info-dark {
  background-color: var(--color-neutral-dark, #404040);
  color: var(--color-neutral-light, #f5f5f5);
}
.container.loading-light, .container.success-light {
  background-color: var(--color-success-light, #dcfce7);
  color: var(--color-success-dark, #15803d);
}
.container.loading-dark, .container.success-dark {
  background-color: var(--color-success-dark, #15803d);
  color: var(--color-success-light, #dcfce7);
}
.container.error-light {
  background-color: var(--color-danger-light, #fef2f2);
  color: var(--color-danger-dark, #b91c1c);
}
.container.error-dark {
  background-color: var(--color-danger-dark, #b91c1c);
  color: var(--color-danger-light, #fef2f2);
}
.container.warning-light {
  background-color: var(--color-warning-light, #ffedd5);
  color: var(--color-warning-dark, #c2410c);
}
.container.warning-dark {
  background-color: var(--color-warning-dark, #c2410c);
  color: var(--color-warning-light, #ffedd5);
}
.item {
  --tw-font-weight: var(--font-weight-normal, 400);
  font-weight: var(--font-weight-normal, 400);
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
}
.container.info-light .item, .container.loading-light .item, .container.success-light .item, .container.warning-light .item, .container.error-light .item {
  color: var(--color-emphasis-high, #000);
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-font-weight: initial;
    }
  }
}
